import { Box, Button, Skeleton, Typography } from '@mui/material';
import { IBudget } from 'common/entities';
import RightDrawer from 'components/BaseLayout/RightDrawer';
import { useAppDispatch, useAppSelector } from 'core/hooks/hooks';
import { closeBudget } from 'core/store/actions/budgets.actions';
import { budgetsSelector } from 'core/store/selectors/budgets.selector';
import { useEffect } from 'react';

interface AccumulationCloseConfirmPanelProps {
  accumulation: IBudget;
  isOpen: boolean;
  onClose: () => void;
}

const AccumulationCloseConfirmPanel = ({
  isOpen,
  onClose,
  accumulation
}: AccumulationCloseConfirmPanelProps) => {
  const dispatch = useAppDispatch();
  const { lastAction, isLoading } = useAppSelector(budgetsSelector);

  useEffect(() => {
    if (
      isOpen &&
      (lastAction === closeBudget.fulfilled.type ||
        lastAction === closeBudget.rejected.type)
    ) {
      onClose();
    }
  }, [lastAction]);

  const handleSubmit = () => {
    dispatch(closeBudget({ budgetId: accumulation.id }));
  };

  return (
    <RightDrawer
      title="Close accumulation"
      isOpen={isOpen}
      closePanel={onClose}
    >
      {isLoading && <Skeleton variant="rectangular" sx={{ height: '50vh' }} />}
      {!isLoading && (
        <Typography variant="body1" sx={{ mb: 2, minHeight: '50vh' }}>
          Close accumulation {accumulation.name}?
        </Typography>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          sx={{ mr: 2 }}
          onClick={handleSubmit}
          disabled={isLoading}
        >
          Close
        </Button>
        <Button variant="outlined" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
      </Box>
    </RightDrawer>
  );
};

export default AccumulationCloseConfirmPanel;
